<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <div class="text item text-center tableheight">
        <el-table :data="tableData1" style="width: 100%" max-height="560" border :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{padding: '7px 0', textAlign: 'center' }">
          <el-table-column label="级别" width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.clevel">
                <el-tag type="primary" v-if="scope.row.clevel=='普通'">{{scope.row.clevel}}</el-tag>
                <el-tag type="danger" size="small" v-if="scope.row.clevel=='紧急'" effect="dark">{{scope.row.clevel}}</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="ctitel" label="公告内容" min-width="220" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ddate" label="日期" width="100"></el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="read(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <NoticeNoticeDel :notvisi="notvisi" @notvisiif="notvisiif" v-if="notvisi" :NoticeDel="NoticeDel" />
  </div>
</template>

<script>
import NoticeNoticeDel from "../../homecharts/NoticeNoticeDel.vue";
export default {
  components: { NoticeNoticeDel },
  data() {
    return {
      notvisi: false,
      NoticeDel: {},
      tableData1: [
        {
          level: "重要",
          content: "通知公告通知1公告通知公告通知公告",
          date: "20214-12-05",
          title: "通知公告",
          cperson: "hahha",
          cisread: "未读",
        },
        {
          level: "普通",
          content: "通知公告通知公告通知公告通知公告",
          date: "20214-12-05",
          title: "通知公告1",
          cperson: "hahha",
          cisread: "已读",
        },
      ],
    };
  },
  created() {
    this.GetAnnouncementList();
  },
  methods: {
    // 通知公告
    GetAnnouncementList() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetAnnouncementList",
      }).then((res) => {
        console.log(res, "通知公告");
        if (res.data.Success) {
          this.tableData1 = res.data.Data;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    notvisiif(val) {
      this.notvisi = val;
    },
    read(val) {
      this.notvisi = true;
      this.NoticeDel = val;
    },
  },
};
</script>

